<script lang="ts" setup>
defineProps<{ disabled: boolean }>()
const emit = defineEmits(['click'])
</script>

<template>
  <button
    type="button"
    id="carousel-right"
    class="cursor-pointer p-2 text-(--brand-primary) hover:text-(--brand-tertiary) disabled:opacity-50 disabled:cursor-not-allowed z-10 transition-opacity"
    aria-label="Slide to right"
    :disabled="disabled"
    @click="emit('click')"
  >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
         stroke="currentColor" class="w-5 h-5">
      <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/>
    </svg>
  </button>
</template>
